import { render } from "./Forgotlogin.vue?vue&type=template&id=e618624c"
import script from "./Forgotlogin.vue?vue&type=script&lang=js"
export * from "./Forgotlogin.vue?vue&type=script&lang=js"

import "./Forgotlogin.vue?vue&type=style&index=0&id=e618624c&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__